var applicationInterests = {
    bindings : {

    },
    /**
     * @ngInject
     */
    controller : function ApplicationInterestsCtrl ($scope, $sce, $timeout, userStore) {
        
        var ctrl = this;
        var message;
        ctrl.messages = [];

        function init () {

        }

        function link () {
            $timeout(function() {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Hey! Velkommen til! Vælg 3 af dine interesser 👻'),
                    type: 'receive'
                });
            }, 500);
        }

        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };

        ctrl.$onInit = init;
        ctrl.$postLink = link;

    },
    templateUrl: './angular/components/application-interests.component.html',
};